import { useNavigate } from "react-router-dom";

const useNavigateWithBase = () => {
    const navigate = useNavigate();
    return (path, options = {}) => {
        if (!path) {
            console.error("❌ navigate() に不正なパスが渡されました:", path);
            return;
        }

        if (options?.state) {
            console.log("📌 navigate の state:", options.state);
        }

        navigate(path, options);
    };
};

export default useNavigateWithBase;
